import DocumentConfiguration, {
    CONFIG_GROUP,
    CONFIG_OPTION,
    MATCHING_CONFIG,
} from '../../../document/pages/Configuration';
import * as DocumentQueries from './queries.tsx';
import { GET_OVERVIEW_DATA } from '../queries.ts';
import { CHANNEL_CONFIG_PATH, CHANNEL_PATH, OVERVIEW_PATH } from '../constants.ts';
import React from 'react';
import { DocumentType } from '../../../document/constants.ts';
import { DocumentTypeName, ValidationCheck } from '../../../document/components/DocumentConfig.tsx';

const Configuration = (props) => {
    const documentConfiguration = {
        service: 'invoices',
        documentType: DocumentType.Invoice,
        documentTypeName: 'invoice',
        activeTab: 'invoice',
        documentQueries: DocumentQueries,
        getOverviewData: GET_OVERVIEW_DATA,
        channelPath: CHANNEL_PATH,
        overviewPath: OVERVIEW_PATH,
        configPath: CHANNEL_CONFIG_PATH,
        supportUserConfigs: { [CONFIG_OPTION.Matching]: MATCHING_CONFIG },
        supportUserConfigGroups: { [CONFIG_GROUP.Processing]: [CONFIG_OPTION.Matching] },
        documentTypes: [
            DocumentTypeName.DeliveryNote,
            DocumentTypeName.Invoice,
            DocumentTypeName.Offer,
            DocumentTypeName.Order,
            DocumentTypeName.OrderConfirmation,
            DocumentTypeName.RequestForQuotation,
        ],
        validationChecks: [
            ValidationCheck.ForgottenLineItems,
            ValidationCheck.IncompleteLineItems,
            ValidationCheck.CustomerInternalNote,
            ValidationCheck.ThousandSeparatorQuantity,
            ValidationCheck.OrderMatching,
            ValidationCheck.TotalAmount,
            ValidationCheck.UniqueDocumentNumber,
        ],
    };

    return <DocumentConfiguration documentConfiguration={documentConfiguration} {...props} />;
};

export default Configuration;
